import { SectionHeader } from "./SectionHeader";

const LAYERS = [
    {
        n: 1,
        name: "Traces",
        desc: "The raw record of an agent session. A prompt, followed by the tool calls it produced: files read, commands run, and results returned, in order.",
    },
    {
        n: 2,
        name: "Workflow Synthesis",
        desc: "Turn a successful run into a reusable workflow. remembered.sh removes the dead ends and keeps the sequence of steps that reached the goal.",
    },
    {
        n: 3,
        name: "Graph Assembly",
        desc: "Connect every workflow. Shared steps and prefixes reveal new paths, letting remembered.sh compose workflows and learn implicit skills.",
    },
    {
        n: 4,
        name: "Retrieval",
        desc: "The layer agents interact with. When an agent starts a task, remembered.sh automatically finds the relevant workflow and guides the agent through it.",
    },
];

const HowItWorks = () => (
    <section id="how-it-works" data-testid="how-it-works-section" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
            <SectionHeader id="how-it-works">How It Works</SectionHeader>
            <div className="flex flex-col gap-px border border-[#262626] bg-[#262626]">
                {LAYERS.map((layer) => (
                    <div
                        key={layer.n}
                        data-testid={`layer-card-${layer.n}`}
                        className="group grid gap-2 bg-[#050505] p-6 transition-colors duration-200 hover:bg-[#0a0a0a] sm:grid-cols-[120px_220px_1fr] sm:items-baseline sm:gap-6 sm:p-8"
                    >
                        <span className="font-mono text-xs tracking-[0.2em] text-neutral-600 transition-colors group-hover:text-green-400">
                            LAYER {layer.n}
                        </span>
                        <h3 className="text-xl font-medium text-neutral-100 sm:text-2xl">{layer.name}</h3>
                        <p className="text-sm leading-relaxed text-neutral-400">{layer.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default HowItWorks;
